import { ToolTypeEnum } from '@shared/constants/campaign.constants';
import { ToolRequestDto } from '@shared/services/apiService';
import { AgentToolsFormValue } from '../model/types';

export const agentToolsRequestMapper = (data: AgentToolsFormValue): ToolRequestDto[] => {
  const tools: ToolRequestDto[] = [];
  const {
    endCallTool,
    callbackRequestTool,
    voiceMailDetectionTool,
    sendFollowUpMessageTool,
    generateWhatsappMessageTool,
    transferTool,
    callHandoffSignalTool,
  } = data;

  if (voiceMailDetectionTool?.enabled) {
    const voiceMailDetectionToolRequest: ToolRequestDto = {
      type: ToolTypeEnum.VoiceMailDetection,
      isAsync: voiceMailDetectionTool?.isAsync || false,
      agentId: data.agentId,
    };
    if (voiceMailDetectionTool?.id) {
      voiceMailDetectionToolRequest.id = voiceMailDetectionTool.id;
    }
    tools.push(voiceMailDetectionToolRequest);
  }

  if (endCallTool?.enabled) {
    const endCallToolRequest: ToolRequestDto = {
      type: ToolTypeEnum.EndCall,
      isAsync: endCallTool?.isAsync || false,
      agentId: data.agentId,
    };
    if (endCallTool?.id) {
      endCallToolRequest.id = endCallTool.id;
    }
    tools.push(endCallToolRequest);
  }

  if (callbackRequestTool?.enabled) {
    const callbackRequestToolRequest: ToolRequestDto = {
      type: ToolTypeEnum.RequestCallback,
      isAsync: callbackRequestTool.isAsync || true,
      agentId: data.agentId,
    };
    if (callbackRequestTool?.id) {
      callbackRequestToolRequest.id = callbackRequestTool.id;
    }
    tools.push(callbackRequestToolRequest);
  }

  if (sendFollowUpMessageTool?.enabled) {
    const sendFollowUpMessageToolRequest: ToolRequestDto = {
      type: ToolTypeEnum.WhatsappMessageSend,
      isAsync: sendFollowUpMessageTool.isAsync || true,
      messageTemplate: sendFollowUpMessageTool.messageTemplate,
      agentId: data.agentId,
    };
    if (sendFollowUpMessageTool?.id) {
      sendFollowUpMessageToolRequest.id = sendFollowUpMessageTool.id;
    }
    tools.push(sendFollowUpMessageToolRequest);
  }

  if (generateWhatsappMessageTool?.enabled) {
    const generateWhatsappMessageToolRequest: ToolRequestDto = {
      type: ToolTypeEnum.GenerateWhatsappMessage,
      isAsync: generateWhatsappMessageTool.isAsync || true,
      agentId: data.agentId,
    };
    if (generateWhatsappMessageTool?.id) {
      generateWhatsappMessageToolRequest.id = generateWhatsappMessageTool.id;
    }
    tools.push(generateWhatsappMessageToolRequest);
  }

  if (transferTool?.enabled) {
    const transferToolRequest: ToolRequestDto & { phoneNumbers?: string[] } = {
      type: ToolTypeEnum.TransferCall,
      isAsync: transferTool.isAsync || true,
      agentId: data.agentId,
      phoneNumbers: transferTool?.phoneNumbers || [],
    };
    if (transferTool?.id) {
      transferToolRequest.id = transferTool.id;
    }
    tools.push(transferToolRequest as ToolRequestDto);
  }

  if (callHandoffSignalTool?.enabled) {
    const request: ToolRequestDto = {
      type: ToolTypeEnum.CallHandoffSignal,
      isAsync: callHandoffSignalTool.isAsync ?? true,
      agentId: data.agentId,
    };
    if (callHandoffSignalTool?.id) request.id = callHandoffSignalTool.id;
    tools.push(request);
  }

  const { genderDetectionTool } = data;
  if (genderDetectionTool?.enabled) {
    const request: ToolRequestDto = {
      type: ToolTypeEnum.GenderDetection,
      isAsync: genderDetectionTool.isAsync ?? true,
      agentId: data.agentId,
      genderSettings: {
        confidenceThreshold: genderDetectionTool.confidenceThreshold,
        durationThreshold: genderDetectionTool.durationThreshold,
        behaviorTemplate: genderDetectionTool.behaviorTemplate,
      },
    };
    if (genderDetectionTool?.id) request.id = genderDetectionTool.id;
    tools.push(request);
  }

  return tools;
};
